export enum Photo {
  Damage = "damagePhotos",
  Vehicle = "vehiclePhotos",
  Additional = "additionalPhotos",
  Mileage = "mileagePhotos",
}

export type UnUploadedImage = {
  id: string;
  type: Photo;
  base64: string;
  src: string;
  alt: string;
  clientImageId: string;
  hash: string;
};
